<template>
  <div class="index-table" :id="referenceId">
    <div class="d-flex" v-if="!innerTable">
      <SearchForm :searchText="searchText" class="w-100" @changeSearch="changeSearch" />
      <TableHeader
        :addLink="addLink"
        :addActionRole="addActionRole"
        @addAction="$emit('addAction')"
      />
    </div>
    <slot name="filter" />
    <slot name="Delete-items" />
    <div :class="innerTable ? '' : 'card'">
      <TableContent>
        <ColumnsHeader :columnHeaders="columnHeaders" @sortItems="sortItems" />
        <slot />
        <Loader v-if="loading == 1" />
        <EmptyTable v-if="loading != 1 && items.length == 0 && error == 0" />
        <Error v-if="loading != 1 && items.length == 0 && error == 1" />
      </TableContent>
      <TableFooter
        v-if="loading != 1 && items.length != 0"
        :page="page"
        :totalPages="totalPages"
        :perPage="perPage"
        @changePage="changePage"
        @changePerPage="changePerPage"
      />
    </div>
    <sureDelete
      v-if="deleteId != null"
      :deleteText="deleteText"
      @closeDelete="closeDelete"
      @deleteItem="deleteItem"
    />
  </div>
</template>
<script>
import TableHeader from './header'
import ColumnsHeader from './table/ColumnsHeader'
import TableContent from './table/index'
import TableFooter from './tableFooter'
import SearchForm from './table/searchForm'
import Loader from './table/loader'
import SureDelete from './table/sureDelete'
import EmptyTable from './table/emptyTable'
import Error from './table/error'

export default {
  components: {
    TableHeader,
    ColumnsHeader,
    TableContent,
    TableFooter,
    Loader,
    SearchForm,
    SureDelete,
    EmptyTable,
    Error
  },

  methods: {
    closeDelete() {
      this.$emit('closeDelete')
    },
    deleteItem() {
      this.$emit('deleteItem')
    },
    sortItems(name) {
      this.$emit('sortItems', name)
    },
    changePage(page) {
      this.$emit('changePage', page)
    },
    changePerPage(item) {
      this.$emit('changePerPage', item)
    },
    changeSearch(search) {
      this.$emit('changeSearch', search)
    },
    doApproveMoveStore(id) {
      axios
        .post(this.$linkGenerator('/storesOrders/approve'), {
          order_id: this.approve_move_store_id,
          from_id: id
        })
        .then((response) => {
          this.approve_move_store_id = null
          return response
        })
    },
    closeApproveMoveToStore() {
      approve_move_store_id = null
    }
  },
  props: [
    'innerTable',
    'referenceId',
    'addLink',
    'loading',
    'error',
    'deleteId',
    'items',
    'columnHeaders',
    'deleteText',
    'searchText',
    'page',
    'totalPages',
    'perPage',
    'addActionRole'
  ]
}
</script>
